import globalIP from '@/GlobelIP';
import React, { useState } from 'react';
import { Button, Message, Modal, toaster } from 'rsuite';

const DeleteModal = ({
  delteModal,
  onClose,
  selectedRowIds,
  setSelectedRowIds,
  fetchData,
  fetchDatat
}) => {
  const [loading, setLoading] = useState(false);

  const deleteCatalogue = async () => {
    try {
      setLoading(true);
      for (const ids of selectedRowIds) {
        // ✅ Update the main product to set Authorized = "Inactive"
        const mainProductUpdateResponse = await fetch(`${globalIP}/api/catalogues/${ids}`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              Status: 'Trash'
            }
          })
        });

        if (mainProductUpdateResponse.ok) {
          console.log(`Product with ID ${ids} marked as Inactive.`);
        } else {
          console.error(`Failed to update main product with ID ${ids}.`);
        }

        // ✅ Update variant products to set Authorized = "Inactive"
      }
      setLoading(false);
      fetchData();
      fetchDatat();
      setSelectedRowIds([]);
      onClose();
      toaster.push(
        <Message showIcon type="success">
          {selectedRowIds.length} Catalogue Deleted Successfully.
        </Message>,
        { placement: 'topEnd' }
      );
    } catch (error) {
      console.error('Error deleting products and variants:', error);
      setLoading(false);
    }
  };

  return (
    <>
      <Modal open={delteModal} onClose={onClose} size="xs" backdrop="static">
        <Modal.Body>
          <Message showIcon type="warning" header="Delete Catalogue">
            Are you sure you want to delete these catalogue? This action cannot be undone.
          </Message>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={deleteCatalogue} appearance="primary" color="cyan" loading={loading}>
            Delete
          </Button>
          <Button onClick={onClose} appearance="subtle" active>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteModal;
